module.exports = __webpack_public_path__ + "img/Totes_Tier.3b0ae638.svg";